import { gql } from '@apollo/client';

/**
 * Get basic user info.
 *
 * NOTE!! this is intentionally very slim as we make this query on each page request for
 * authenticated users (see `auth/index.ts`).
 *
 * If you need additional user fields, please do not just add to this query; compose the query
 * strings such that this one still seems simple.
 */

export const GET_USER = gql`
  query User {
    user {
      id
      firstName
      lastName
      name
      email
      initials
      phone
      creditInCents
    }
  }
`;
